import { getPublishedCalendarLeftPaneStore } from '../store/publishedCalendarLeftPaneStore';
import { mutator } from 'satcheljs';
import toggleLeftPane from '../actions/toggleLeftPane';

/**
 * Mutator that toggles the left pane
 */
mutator(toggleLeftPane, actionMessage => {
    getPublishedCalendarLeftPaneStore().isLeftPaneExpanded = !getPublishedCalendarLeftPaneStore()
        .isLeftPaneExpanded;
});
